import React from 'react';
import { useLocation, Outlet, Navigate } from 'react-router-dom';
import userStore from 'store/UserStore';
import { AUTH_ROUTE, USERS_ROUTE } from 'routes/paths';
import { observer } from 'mobx-react';
import { DefaultLayout } from 'layout/DefaultLayout';
import { UserRoles } from 'enums';

type RequireAuthProps = {
  allowedRoles: UserRoles[];
};

const RequireAuth = ({ allowedRoles }: RequireAuthProps) => {
  const location = useLocation();

  const isAdminOrSupport =
    allowedRoles.includes(UserRoles.ADMIN) ||
    allowedRoles.includes(UserRoles.SUPPORT);

  if (allowedRoles.includes(userStore.role)) {
    return isAdminOrSupport ? (
      <DefaultLayout>
        <Outlet />
      </DefaultLayout>
    ) : (
      <Outlet />
    );
  }
  return (
    <Navigate
      to={isAdminOrSupport ? AUTH_ROUTE : USERS_ROUTE}
      state={{ from: location }}
      replace
    />
  );
};

const RequireAuthObserver = observer(RequireAuth);

export { RequireAuthObserver as RequireAuth };
